import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getEdokForms = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.edok.forms.entries, filter);
};
